// =============================================================================
// The sticky header's condensed state.
//
// `.site-header.is-scrolled` tightens the bar and adds its background once the
// page has moved off the top; CSS owns the transition and this only decides
// when the class applies.
// =============================================================================

/** How far down the page has to be, in px, before the header condenses. */
const SCROLL_THRESHOLD = 8;

export default function initHeader() {
	const header = document.querySelector(".site-header");
	if (!header) {
		return;
	}

	const onScroll = () => {
		header.classList.toggle("is-scrolled", window.scrollY > SCROLL_THRESHOLD);
	};

	// Once immediately, not only on the next scroll event: a page that loads
	// already scrolled — a refresh halfway down, or a back-navigation restored
	// to position — would otherwise keep the expanded header until the visitor
	// happens to move it.
	onScroll();

	// Passive because the handler never calls preventDefault(), and a
	// non-passive scroll listener makes the browser wait on it before painting.
	window.addEventListener("scroll", onScroll, { passive: true });
}
